<h5 class="zint-card-title max-width-85">{{ label }}</h5>

@if(!pubMethods.hasData(series)) {
<div class="aira-nodata-icon-backdrop">
    <i class="fa-duotone fa-thin fa-chart-pie-simple"></i>
    <p>No insights have been derived.</p>
</div>
}
@else {

    <donut-chart [donutData]="donutInput" [ngClass]="{'blur-content-strong': previewOnly}"></donut-chart>
}
